import React from 'react'

// A centered empty-state panel for a page or section that has no data yet: a
// soft icon badge, a title, an optional explanatory line, and optional call(s)
// to action passed as children. Shared so every "nothing here yet" surface reads
// the same across the apps.
export interface EmptyStateProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: React.ComponentType<any>
  title: string
  message?: string
  children?: React.ReactNode
  className?: string
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, message, children, className = '' }) => (
  <div className={`flex flex-col items-center justify-center rounded-lg border border-gray-200 bg-white px-6 py-16 text-center shadow-xs ${className}`}>
    {Icon && (
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-perfect-shine-50">
        <Icon className="h-6 w-6 text-perfect-shine" aria-hidden="true" />
      </div>
    )}
    <h2 className="mt-5 text-lg font-semibold text-gray-900">{title}</h2>
    {message && <p className="mt-2 max-w-md text-sm text-gray-600">{message}</p>}
    {children && <div className="mt-6 flex items-center justify-center gap-3">{children}</div>}
  </div>
)

export default EmptyState
